import React from "react"
import styled, { css } from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"
import { bodyBold } from "@constants//typography"
import { Label, CountWrapper, Count } from "@components/MenuItem/common"

const Button = styled.button<{ showCount?: boolean; marginTop?: string }>`
  ${({ showCount, marginTop }) => css`
    ${bodyBold}
    z-index: 1;
    position: relative;
    align-items: center;
    justify-content: center;
    display: flex;
    width: ${showCount ? "90px" : "72px"};
    height: 44px;
    margin-top: ${marginTop ? marginTop : "-44px"};
    margin-left: 20px;
    outline: none;
    border: 1px solid ${colors.divider};
    border-radius: 2px;
    background: ${colors.snow};
    text-align: center;

    ${up("laptop")} {
      display: none;
    }

    ${Label} {
      color: ${colors.slateDark};
    }

    ${CountWrapper} {
      position: relative;
      right: initial;
      margin-left: 4px;
    }
  `}
`

interface FilterButtonProps {
  filterCount: number
  marginTop?: string
  onClick?: (e) => void
}

const FilterButton: React.FC<FilterButtonProps> = ({
  filterCount,
  marginTop,
  onClick,
}) => {
  return (
    <Button showCount={filterCount > 0} marginTop={marginTop} onClick={onClick}>
      <Label>Filter</Label>
      {filterCount > 0 && (
        <CountWrapper>
          <Count>{filterCount}</Count>
        </CountWrapper>
      )}
    </Button>
  )
}

export default FilterButton
